import React from 'react';
import { Page } from '../Page';
import { Dumbbell, Shield, Sparkles, Activity } from 'lucide-react';
export function Page9() {
  return <Page pageNumber={25} variant="light" data-id="element-1103" data-mp="39isjm6ukl3ub">
      <div className="flex flex-col h-full" data-id="element-1104" data-mp="3ehnei75taius">
        {/* Hero Image Header */}
        <div className="relative h-[320px] -mx-12 -mt-10 mb-6 overflow-hidden" data-id="element-1105" data-mp="3efj1mzpxq9id">
          <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1000&q=80" alt="Weight lifting gym" className="w-full h-full object-cover" data-id="element-1106" data-mp="3j9ewvuetdi9u" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-[#F5F5F0]/40 to-transparent" data-id="element-1107" data-mp="3sav6hzxt1gd0" />

          <div className="absolute bottom-0 left-12 right-12 pb-6" data-id="element-1108" data-mp="10mq7t9c8872">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-1109" data-mp="6121mfa275me">
              The Essentials
            </p>
            <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight" data-id="element-1110" data-mp="27sxc4rkkx431">
              Weight <span className="text-tealslate" data-id="element-1111" data-mp="27urvw2k46q5j">Lifting</span>
            </h1>
          </div>
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-6 max-w-2xl" data-id="element-1112" data-mp="27guz6f0v592m">
          When you lose weight, you lose both fat and muscle. GLP-1 medications
          accelerate this process. If you do not actively signal your body to
          keep your muscle, you will lose it. Weight lifting is that signal.
        </p>

        <div className="grid grid-cols-2 gap-8 mb-6" data-id="element-1113" data-mp="2v6z0gfqkwwqg">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-6 text-center flex flex-col justify-center h-fit" data-id="element-1114" data-mp="2v4cv8mr5utbe">
            <h2 className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-2" data-id="element-1115" data-mp="2q5jd2h0xie4w">
              The Goal
            </h2>
            <div className="text-3xl font-serif text-[#1F1F1F] mb-3" data-id="element-1116" data-mp="2h7fxs2gjedlj">
              2 Times
              <br data-id="element-1117" data-mp="19tcr76f10azo" />
              Per Week
            </div>
            <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1118" data-mp="19qrnscz2xmzt">
              A full-body workout hitting muscles from your shoulders to your
              calves. Each session should work your whole body.
            </p>
          </div>

          <div className="space-y-4" data-id="element-1119" data-mp="1c814vxcn831n">
            <h2 className="text-xl font-serif text-[#1F1F1F] mb-3 border-b border-[#D8D8D0] pb-2" data-id="element-1120" data-mp="1c6zt1qnszciv">
              Why It's Essential
            </h2>
            <div className="space-y-3" data-id="element-1121" data-mp="12925749uvhqs">
              <div className="flex items-start gap-3" data-id="element-1122" data-mp="1280j84raxaua">
                <Shield className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-1123" data-mp="ohnba2eetw4y" />
                <div data-id="element-1124" data-mp="t8wy6v8kqld5">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-1125" data-mp="t9f4ylsv4hzb">
                    Protect Muscles
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-1126" data-mp="elbyzcetl6ai">
                    Preserve your strength and metabolism while losing weight.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-1127" data-mp="5k4a1ky71ht3">
                <Sparkles className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-1128" data-mp="9lfu7ayatatw" />
                <div data-id="element-1129" data-mp="3n200570687qo">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-1130" data-mp="3n188265s8s55">
                    Skin Elasticity
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-1131" data-mp="3i4hv3rp9ycny">
                    Building muscle helps reduce the appearance of loose skin.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-1132" data-mp="3r5pqa0whuxdt">
                <Dumbbell className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-1133" data-mp="9uooikqhzpwk" />
                <div data-id="element-1134" data-mp="4wn6820wbum5">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-1135" data-mp="4vc0hwnw4cse">
                    Toned Appearance
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-1136" data-mp="in0ds39vl7ay">
                    Give your body a firmer, more defined look as the fat comes
                    off.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-1137" data-mp="nn4thr2yly04">
                <Activity className="w-5 h-5 text-tealslate shrink-0 mt-0.5" data-id="element-1138" data-mp="nopmhc9ml8vv" />
                <div data-id="element-1139" data-mp="17o7t15x1404d">
                  <h3 className="text-sm font-bold text-[#1F1F1F] mb-0.5" data-id="element-1140" data-mp="17or17uwvna57">
                    Medication Synergy
                  </h3>
                  <p className="text-xs text-[#7A7A70] leading-[1.6]" data-id="element-1141" data-mp="1ghkuwxd2mc2l">
                    Improves insulin sensitivity, helping your GLP-1 work
                    better.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1 flex items-end" data-id="element-1142" data-mp="oshkt0yi67i1">
          <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-4 flex gap-4 items-center w-full" data-id="element-1143" data-mp="ssrvus15jo3r">
            <div className="flex-1" data-id="element-1144" data-mp="xq1qqn7b8ryz">
              <h3 className="font-serif text-base text-[#1F1F1F] mb-1" data-id="element-1145" data-mp="xsw8g6yxvyop">
                Need a Structured Program?
              </h3>
              <p className="text-[11px] text-[#7A7A70] leading-[1.5]" data-id="element-1146" data-mp="296hzxys9ucde">
                If you're looking for a personalized workout plan from me, check
                out my training app below! Try it free for one month with code{' '}
                <strong className="text-[#1F1F1F]" data-id="element-1147" data-mp="2h6jqay2ym41">ONEMONTH</strong>. After
                that, it's $6.99 per month and gives you access to a full
                exercise library, workout tracking, and guidance on how to
                maximize results.
              </p>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/4sEENWegwxqKTrFHmP9mzr/Untitled_1.png" alt="Training App QR Code" className="w-12 h-12 shrink-0" data-id="element-1148" data-mp="3jxg25utiawnu" />
          </div>
        </div>
      </div>
    </Page>;
}